// extracted by mini-css-extract-plugin
var _1 = "HeaderStyle-module__header-logo___Pn15_";
var _2 = "HeaderStyle-module__header-text___Z2aeb";
var _3 = "HeaderStyle-module__header-logo___Pn15_";
var _4 = "HeaderStyle-module__header-text___Z2aeb";
export { _1 as "header-logo", _2 as "header-text", _3 as "headerLogo", _4 as "headerText" }
